exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 992px){\n#welcome .navbar{background:white !important;-webkit-box-shadow:unset;box-shadow:unset\n}\n#welcome .navbar .dropdown-toggle{color:#333;border-radius:20px;padding-left:1rem;padding-right:1rem\n}\n#welcome .navbar .dropdown-toggle:hover{background-color:#fff;color:#333\n}\n#welcome .navbar .logo{fill:#fff\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/pages/welcome.vue
// module id = OJPh
// module chunks = 53